import { render, staticRenderFns } from "./FormFreightRate.vue?vue&type=template&id=4fbce87e&scoped=true"
import script from "./FormFreightRate.vue?vue&type=script&lang=js"
export * from "./FormFreightRate.vue?vue&type=script&lang=js"
import style0 from "./FormFreightRate.vue?vue&type=style&index=0&id=4fbce87e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbce87e",
  null
  
)

export default component.exports